import { Directive, Component, ElementRef, OnChanges, SimpleChanges, Input, Attribute, Renderer2, Inject, PLATFORM_ID } from "@angular/core";
import { DOCUMENT, isPlatformBrowser } from "@angular/common";
import { Helper } from '@app/core/helper';
import { environment } from '@env/environment';
function _isSvg(url: string) {
    return url && (url.substr(-4) === '.svg')
}
function _encUri(str: string) {
    return encodeURIComponent(str);
}
function _prepQueryParams(str: string) {
    return '?' + str.replace(/,/g, '&');
}

@Directive({
    selector: ':not(picture):not(iframe)[xSrc]',
})
export class AnyXSrcDirective implements OnChanges {
    @Input('xSrc')
    set _xSrc(src: string) {
        src = src || this.altSrc;
        this.xSrc = src ? Helper.parseUrl(src).pathname : '';;
    }
    public xSrc!: string;

    @Input('xSrcset')
    public xSrcSet: any;
    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
        @Attribute('altSrc')
        private altSrc: string,
        @Attribute('xSizes')
        private xSizes: string,
        @Attribute('loading')
        private loading: string,
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        const src = this.xSrc;
        const el = this.el.nativeElement;
        const map: any = { 'img': 'src', 'source': 'srcset' };
        const attr = map[this.el.nativeElement.localName] || 'href';
        if ((attr === 'src') && !this.loading) {
            this.el.nativeElement.setAttribute('loading', 'lazy');
        }
        if (src) {
            let xsrc = Helper.applyCdn(src);
            let srcset = '';
            let sizes = '';
            if (this.xSrcSet && !_isSvg(xsrc)) {
                const bounds = [];
                let hasStar = false;
                for (let b in this.xSrcSet) {
                    const curSrcSet = this.xSrcSet[b];
                    const resSrc = Helper.applyCdn(src) + _prepQueryParams(curSrcSet);
                    let m;
                    if (b === '*') {
                        hasStar = true;
                        xsrc = resSrc;
                    } else if (m = ('' + b).match(/^\d+/)) {
                        const data: any = { i: +m[0], s: b, u: resSrc };
                        if (m = curSrcSet.match(/(w|width)=(\d+)/)) {
                            data.a = +m[2];
                        } else {
                            throw 'Invalid srcset expression "' + curSrcSet + '". You must fill w or width parameter in boundary "' + b + '".';
                        }
                        bounds.push(data);
                        srcset += (srcset === '' ? '' : ', ') + resSrc + ' ' + data.a + 'w';
                    } else {
                        throw 'Invalid boundary expression "' + b + '"';
                    }
                    if (hasStar && bounds.length) {
                        throw 'Invalid srcset expression "' + JSON.stringify(this.xSrcSet) + '". You must not use star boundary (*) with other bounaries.';
                    }
                }
                if (!bounds.length) {
                } else if (bounds.length === 1) {
                    throw 'Invalid srcset expression "' + JSON.stringify(this.xSrcSet) + '". You must specify single star (*) boundary instead of "' + bounds[0].s + '".';
                } else if (this.xSizes) {
                    sizes = this.xSizes;
                    xsrc = bounds[bounds.length - 1].u;
                } else {
                    const sortedBounds = bounds.sort((a, b) => a.i === b.i ? 0 : (a.i > b.i ? 1 : -1)); // asc order
                    for (let idx in bounds) {
                        if (+idx === bounds.length - 1) { // large
                            sizes += ', ' + bounds[idx].a + 'px';
                            xsrc = bounds[idx].u;
                        } else { // medium or small
                            sizes += (sizes === '' ? '' : ', ') + '(max-width: ' + bounds[idx].i + 'px) ' + bounds[idx].a + 'px';
                        }
                    }
                }
            }
            if (el.hasAttribute('srcset')) {
                const setSrc = el.getAttribute('srcset');
                const setSrcSize = setSrc.split(', ');
                if (setSrcSize.length == 2) {
                    srcset = Helper.applyCdn(setSrcSize[0]) + ' 1x, ' + Helper.applyCdn(setSrcSize[1]) + ' 2x';
                }
            }
            this.renderer.setAttribute(el, 'sizes', sizes);
            this.renderer.setAttribute(el, 'srcset', srcset);
            if (attr === 'src') {
                this.renderer.setAttribute(el, attr, xsrc);
            }
            if (attr === 'srcset' && el.getAttribute('srcset') == '') {
                this.renderer.setAttribute(el, attr, xsrc);
            }
            if (this.altSrc && (src !== this.altSrc)) {
                el.onload = () => {
                    el.onload = el.onerror = null;
                    if ((el.naturalWidth < 5) && (el.naturalHeight < 5)) {
                        this.renderer.setAttribute(el, attr, Helper.applyCdn(this.altSrc));
                        this.renderer.setAttribute(el, 'srcset', '');
                        this.renderer.setAttribute(el, 'sizes', '');
                    }
                };
                el.onerror = () => {
                    el.onload = el.onerror = null;
                    this.renderer.setAttribute(el, attr, Helper.applyCdn(this.altSrc));
                    this.renderer.setAttribute(el, 'srcset', '');
                    this.renderer.setAttribute(el, 'sizes', '');
                };
            }
        } else {
            this.renderer.setAttribute(el, attr, '');
            this.renderer.setAttribute(el, 'srcset', '');
            this.renderer.setAttribute(el, 'sizes', '');
        }
    }
}

@Component({
    selector: 'picture[xSrc]',
    template: '',
})
export class PictureXSrcDirective implements OnChanges {
    @Input('xSrc')
    set _xSrc(src: string) {
        src = src || this.altSrc;
        this.xSrc = src ? Helper.parseUrl(src).pathname : '';;
    }
    public xSrc!: string;
    public altSrc: string;

    @Input()
    public xSrcset: any;

    @Input()
    public sSrcset: any;

    @Input()
    public alt!: string;

    @Input()
    public title!: string;

    @Input()
    public size!: string[];

    @Input()
    public loading!: string;

    @Input()
    public default!: string;

    @Input()
    public defaultSlice: number = 1;

    constructor(
        @Inject(PLATFORM_ID)
        private pid: any,
        private el: ElementRef,
        @Inject(DOCUMENT)
        private document: Document,
        @Attribute('altSrc')
        altSrc: string,
    ) {

        this.altSrc = altSrc ? Helper.parseUrl(altSrc).pathname : '';
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.genSources(this.xSrc);
    }

    private genSources(src: string): void {
        const el = this.el.nativeElement;
        while (el.firstChild) {
            el.removeChild(el.firstChild);
        }
        if (src) {
            let xsrc = Helper.applyCdn(src);
            if (this.xSrcset && !_isSvg(xsrc)) {
                const bounds = [];
                let hasStar = false;
                for (let b in this.xSrcset) {
                    const curSrcSet = this.xSrcset[b];
                    const resSrc = Helper.applyCdn(src) + _prepQueryParams(curSrcSet);
                    let m;
                    if (b === '*') {
                        hasStar = true;
                        xsrc = resSrc;
                    } else if (m = ('' + b).match(/^\d+/)) {
                        bounds.push({ i: +m[0], s: b, u: resSrc });
                    } else {
                        throw 'Invalid boundary expression "' + b + '"';
                    }
                    if (hasStar && bounds.length) {
                        throw 'Invalid srcset expression "' + JSON.stringify(this.xSrcset) + '". You must not use star boundary (*) with other bounaries.';
                    }
                }
                if (!bounds.length) {
                } else if (bounds.length === 1) {
                    throw 'Invalid srcset expression "' + JSON.stringify(this.xSrcset) + '". You must specify single star (*) boundary instead of "' + bounds[0].s + '".';
                } else {
                    const sortedBounds = bounds.sort((a, b) => a.i === b.i ? 0 : (a.i > b.i ? 1 : -1)); // asc order
                    for (let idx in bounds) {
                        if (+idx === bounds.length - 1) { // large
                            xsrc = bounds[idx].u;
                        } else { // medium or small
                            const source = this.document.createElement('SOURCE');
                            if (this.sSrcset) {
                                let szSrcSet = (Helper.applyCdn(src)) + _prepQueryParams(this.sSrcset[bounds[idx].s]);
                                source.setAttribute('srcset', bounds[idx].u + ' 1x, ' + szSrcSet + ' 2x');
                            } else if (!this.sSrcset) {
                                source.setAttribute('srcset', bounds[idx].u);
                            }
                            const minMax = bounds[idx].s.split(/-|,/);
                            if (minMax.length > 1) {
                                let ct = 2;
                                const mds = (n: any) => '(max-width: ' + minMax[n - 2] + ') and (min-width: ' + minMax[n - 1] + ')';
                                if (minMax.length == 2) {
                                    source.setAttribute('media', mds(2));
                                } else if (minMax.length == 4) {
                                    source.setAttribute('media', mds(2) + ', ' + mds(4));
                                } else if (minMax.length == 6) {
                                    source.setAttribute('media', mds(2) + ', ' + mds(4) + ', ' + mds(6));
                                } else if (minMax.length == 8) {
                                    source.setAttribute('media', mds(2) + ', ' + mds(4) + ', ' + mds(6) + ', ' + mds(8));
                                }
                            } else {
                                source.setAttribute('media', '(max-width: ' + bounds[idx].s + ')');
                            }
                            el.appendChild(source);
                        }
                    }
                }
            }
            const img: any = this.document.createElement('IMG');
            img.setAttribute('loading', this.loading || 'lazy');
            img.setAttribute('src', xsrc);
            img.setAttribute('alt', this.alt || '');
            img.setAttribute('title', this.title || '');
            if (this.sSrcset && !_isSvg(xsrc)) {
                let sSrcsetKey = Object.keys(this.sSrcset);
                let szSrcSet = Helper.applyCdn(src) + _prepQueryParams(this.sSrcset[sSrcsetKey[0]]);
                img.setAttribute('srcset', xsrc + ' 1x, ' + szSrcSet + ' 2x');
            }
            const s = this.size;
            if (Array.isArray(s) && (s.length === 2)) {
                img.setAttribute('width', s[0]);
                img.setAttribute('height', s[1]);
            }
            if (this.default || (this.altSrc && (src !== this.altSrc))) {
                img.onload = () => {
                    img.onload = el.onerror = null;
                    if ((img.naturalWidth < 5) && (img.naturalHeight < 5)) {
                        this.genSources(this.altSrc);
                    }
                };
                img.onerror = () => {
                    img.onload = img.onerror = null;
                    this.genSources(this.altSrc);
                };
            }
            el.appendChild(img);
        } else if (this.default) {
            const span: any = this.document.createElement('SPAN');
            const attr = isPlatformBrowser(this.pid) ? 'innerText' : 'textContent';
            if (this.title) {
                span.setAttribute('title', this.title)
            }
            span[attr] = this.default.slice(0,this.defaultSlice)
            el.appendChild(span);
        }
    }
}
